import './footer.scss';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div>© {year} Arisa Nemoto. All rights reserved.</div>
    </footer>
  );
}
